var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "color-picker-wrapper" },
    [
      _c(
        "div",
        { on: { click: _vm.togglePicker } },
        [
          _vm._t("default", function () {
            return [
              _c("div", { staticClass: "color-preview" }, [
                _c("div", {
                  staticClass: "color-swatch",
                  style: { backgroundColor: _vm.displayColor },
                }),
                _vm.showValue
                  ? _c("span", { staticClass: "color-value" }, [
                      _vm._v(_vm._s(_vm.displayValue)),
                    ])
                  : _vm._e(),
                _c("span", { staticClass: "color-arrow" }, [_vm._v("▼")]),
              ]),
            ]
          }),
        ],
        2
      ),
      _c("transition", { attrs: { name: "slide" } }, [
        _vm.showPicker
          ? _c(
              "div",
              { staticClass: "color-picker-popover" },
              [
                _c("div", {
                  staticClass: "color-picker-cover",
                  on: { click: _vm.closePicker },
                }),
                _c("SketchPicker", {
                  attrs: { value: _vm.colorObject },
                  on: { input: _vm.handleColorChange },
                }),
              ],
              1
            )
          : _vm._e(),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }